import { Stack, StackProps } from '@mui/material';
import React, { ReactNode } from 'react';

import { Loader } from '@sbu/components.loader';
import { useUserPrivileges } from '@sbu/hooks.userprivileges';

import { ConfigPageHeader } from './ConfigPageHeader';
import {
  configPagePrivileges,
  ConfigPageValue,
  headerPropsMap,
} from './constants';

export interface ConfigPageProps extends Pick<StackProps, 'children'> {
  currentPage: ConfigPageValue;
  renderSecondaryNav?: () => ReactNode;
}

export const ConfigPage = ({
  children,
  currentPage,
  renderSecondaryNav,
}: ConfigPageProps) => {
  const { data, isLoading } = useUserPrivileges(configPagePrivileges);

  const headerProps = {
    ...headerPropsMap[currentPage],
    pages: headerPropsMap[currentPage].pages.filter(
      ({ requiredPrivileges: [privilege, _] }) => {
        return (data?.privileges ?? []).find(
          ({ key, value }) => key === privilege && value
        );
      }
    ),
  };

  return (
    <Stack p={3} height='100%'>
      {isLoading ? (
        <Loader height='100%' size='xlarge' />
      ) : (
        <>
          {headerProps && (
            <ConfigPageHeader currentPage={currentPage} {...headerProps} />
          )}
          {renderSecondaryNav && (
            <Stack direction='row' justifyContent='center' my={3}>
              {renderSecondaryNav()}
            </Stack>
          )}
          <Stack direction='row' gap={2} flexGrow={1} overflow='auto'>
            {children}
          </Stack>
        </>
      )}
    </Stack>
  );
};
